import { Alert, styled, Typography } from "@mui/material";
import { useMemo } from "react";
import { LinkWrapper } from "../../ui/anchor/LinkWrapper";
import { pageMapping } from "../../../builder/mapping/page";
import { useLocale } from "../../../helpers/locale";
import Tooltip from "../Tooltip";

interface Props {
  description?: string;
  path?: string;
}

const StyledTypography = styled(Typography)(() => ({
  fontSize: "inherit",
  "p&::first-letter": {
    textTransform: "initial",
  },
}));

const StyledLinkWrapper = styled(LinkWrapper)(() => ({
  textDecoration: "none",
  color: "inherit",
  "&:hover": {
    textDecoration: "underline",
  },
}));

function LinkToPreview({ description, path }: Props) {
  const { locale } = useLocale();
  const url = useMemo(
    () =>
      window.location.origin +
      pageMapping.PLP.path +
      (locale || "") +
      (path || ""),
    [locale, path],
  );

  return (
    <Alert severity="warning">
      {description}{" "}
      <Tooltip title={`Go To ${url}`}>
        <span>
          <StyledLinkWrapper href={url} target="_blank">
            <StyledTypography noWrap>{url}</StyledTypography>
          </StyledLinkWrapper>
        </span>
      </Tooltip>
    </Alert>
  );
}

export default LinkToPreview;
